/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import {withStyles, withStylesCompose} from '../hocs/withStyles';
import {withNeutral50, withNeutral900} from '../hocs/withColors';
import {
  withUppercaseBold,
  withUppercaseXBold,
  withPSmall,
  withPSmallLh,
  withPSmallLhBase,
  withPSmallLhBaseNoMargin,
  withH1NoMargin,
  withH2NoMargin,
  withH2Smaller,
  withPNoMargin,
  withPMarginSm,
  withPMarginTMd,
  withMark,
  withPSmallMarginSm
} from '../hocs/withFontType';

const PlainH1 = props => <h1 {...props} />;
const PlainH2 = props => <h2 {...props} />;
const PlainH3 = props => <h3 {...props} />;
const PlainH4 = props => <h4 {...props} />;
const PlainH5 = props => <h5 {...props} />;
const PlainP = props => <p {...props} />;
const PlainMark = props => <mark {...props} />;
const H1 = withStyles(PlainH1, 'h1');
const H1NoMargin = withStylesCompose(withH1NoMargin(PlainH1, 'h1'));
const H1Neutral50 = withNeutral50(withStyles(H1NoMargin, 'h1'));
const H2 = withStyles(PlainH2, 'h2');
const H2NoMargin = withStylesCompose(withH2NoMargin(PlainH2, 'h2'));
const H2Neutral50 = withNeutral50(withStyles(PlainH2, 'h2'));
const H2SmallerNeutral900 = withNeutral900(withH2Smaller(PlainH2, 'h2'));
const H3 = withStyles(PlainH3, 'h3');
const H4 = withStyles(PlainH4, 'h4');
const H5 = withStylesCompose(PlainH5, 'h5');
const H5Neutral50 = withNeutral50(withStylesCompose(withUppercaseXBold(PlainH5, 'h5')));
const H5Neutral900Light = withNeutral900(withStylesCompose(withUppercaseBold(PlainH5, 'h5')));
const P = withStyles(PlainP, 'p');
const PNeutral50 = withNeutral50(withStyles(PlainP, 'p'));
const PSmall = withStylesCompose(withPSmall(PlainP, 'p'));
const PSmallLh = withStylesCompose(withPSmallLh(PlainP, 'p'));
const PSmallLhBase = withStylesCompose(withPSmallLhBase(PlainP, 'p'));
const PSmallLhBaseNoMargin = withStylesCompose(withPSmallLhBaseNoMargin(PlainP, 'p'));
const PNoMargin = withStylesCompose(withPNoMargin(PlainP, 'p'));
const PSmallNoMargin = withStylesCompose(withPNoMargin(PSmall, 'p'));
const PSmallLhNoMargin = withStylesCompose(withPNoMargin(PSmallLh, 'p'));
const PMarginTMd = withStylesCompose(withPMarginTMd(PlainP, 'p'));
const PMarginSm = withStylesCompose(withPMarginSm(PlainP, 'p'));
/**
 * Redesign 2024
 * */
const Mark = withMark(withStyles(PlainMark, 'mark'));
const PlainH6 = props => <h6 {...props} />;
const PSmallMarginSm = withStylesCompose(withPSmallMarginSm(PlainP, 'p'));
const H3Neutral50 = withNeutral50(withStyles(PlainH3, 'h3'));
const H6 = withStyles(PlainH6, 'h6');

export {
  H1,
  H1Neutral50,
  H2,
  H2NoMargin,
  H2Neutral50,
  H2SmallerNeutral900,
  H3,
  H4,
  H5,
  H5Neutral50,
  H5Neutral900Light,
  H6,
  P,
  PNeutral50,
  PSmall,
  PSmallLhBase,
  PSmallLhBaseNoMargin,
  PNoMargin,
  PMarginTMd,
  PSmallNoMargin,
  PSmallLhNoMargin,
  PMarginSm,
  /**
   * Redesign 2024
   * */
  Mark,
  PlainH6,
  PSmallMarginSm,
  H3Neutral50
};
